module.exports = __webpack_public_path__ + "img/01-images-girl-mgs-m.178fbb52.png";